<script setup>
import { DialogPanel as HeadlessDialogPanel, TransitionChild } from "@headlessui/vue";
import { twMerge } from "tailwind-merge";

const props = defineProps({
  theme: {
    type: String,
    default: "rose",
    validator: (v) => ["teal", "grape", "iceberg", "rose", "offsite"].includes(v),
  },
  highContrast: {
    type: Boolean,
    default: false,
  },
});

defineOptions({ inheritAttrs: false });
</script>

<template>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-dvh items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to="opacity-100 translate-y-0 sm:scale-100"
        leave="ease-in duration-200"
        leave-from="opacity-100 translate-y-0 sm:scale-100"
        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <HeadlessDialogPanel
          :class="
            twMerge(
              'relative my-8 min-w-96 transform space-y-4 rounded-lg border border-primary bg-background p-6 text-left shadow-xl transition-all',
              theme && theme === 'teal' && !highContrast && 'border-theme-teal',
              theme && theme === 'teal' && highContrast && 'border-theme-teal-hc',
              theme && theme === 'grape' && !highContrast && 'border-theme-grape',
              theme && theme === 'grape' && highContrast && 'border-theme-grape-hc',
              theme && theme === 'iceberg' && !highContrast && 'border-theme-iceberg',
              theme && theme === 'iceberg' && highContrast && 'border-theme-iceberg-hc',
              theme && theme === 'rose' && !highContrast && 'border-theme-rose',
              theme && theme === 'rose' && highContrast && 'border-theme-rose-hc',
              theme && theme === 'offsite' && !highContrast && 'border-theme-offsite',
              theme && theme === 'offsite' && highContrast && 'border-theme-offsite-hc',
            )
          "
          v-bind="$attrs"
        >
          <slot />
        </HeadlessDialogPanel>
      </TransitionChild>
    </div>
  </div>
</template>
